import {DefinedActionPerformer} from 'shared/defined-actions';
import  register from '@kpsys/angularjs-register';

export default register('portaro.shared.defined-actions')
    .service(DefinedActionPerformer.serviceName, DefinedActionPerformer)
    .name()